export default "__VITE_ASSET__f96266ac__"